(() => {
  "use strict";

  window.zag = window.zag || {};

  window.zag.components.ZagNewsletterPopin = class extends (
    window.zag.components.ZagComponent
  ) {
    connectedCallback() {
      this.events.add(this.section, "click", (event) => {
        if (event.target == this.section) {
          this.hide();
        }
      });
      this.events.add(this.closeButton, "click", this.hide);

      if (this.submitButton) {
        this.events.add(this.submitButton, "click", this.onSubmitButtonClick);
      }

      if (this.form) {
        this.events.add(this.form, "submit", this.onFormSubmit);
      }

      if (this.emailInput) {
        this.events.add(this.emailInput, "input", this.onEmailInput);
      }

      if (this.confidentialityCheckbox) {
        this.events.add(
          this.confidentialityCheckbox,
          "change",
          this.onCheckboxChange
        );
      }

      this.checkAndShow();
    }

    get popinContainer() {
      return this.cache.get("dom", "popinContainer", () => {
        return this.querySelector(".popin-container");
      });
    }

    get form() {
      return this.cache.get("dom", "form", () => {
        return this.querySelector("form");
      });
    }

    get emailInput() {
      return this.cache.get("dom", "emailInput", () => {
        return this.querySelector("input[name='contact[email]']");
      });
    }

    get confidentialityCheckbox() {
      return this.cache.get("dom", "confidentialityCheckbox", () => {
        return this.querySelector(".confidentiality-checkbox input");
      });
    }

    get emailErrorElement() {
      return this.cache.get("dom", "emailErrorElement", () => {
        return this.querySelector(".form-error--email");
      });
    }

    get checkboxErrorElement() {
      return this.cache.get("dom", "checkboxErrorElement", () => {
        return this.querySelector(".form-error--checkbox");
      });
    }

    get submitButton() {
      return this.cache.get("dom", "submitButton", () => {
        return this.querySelector(".submit-newsletter-button");
      });
    }

    get closeButton() {
      return this.cache.get("dom", "closeButton", () => {
        return this.querySelector(".popin-close");
      });
    }

    get appearanceDelay() {
      return this.cache.get("dom", "appearanceDelay", () => {
        return (
          this.modifiers
            .list()
            .find((modifier) => modifier.startsWith("appearance-delay:"))
            ?.split(":")[1] || 0
        );
      });
    }

    checkAndShow = () => {
      if (window.location.hash === `#${this.form.id}`) {
        this.show();
        window.localStorage.setItem("showNewsletterPopin", "false");
        return;
      }

      const showPopin = window.localStorage.getItem("showNewsletterPopin");
      if (showPopin === "false") {
        return;
      }

      const delay = parseInt(this.appearanceDelay);
      if (delay === 0) {
        window.localStorage.setItem("showNewsletterPopin", "false");
        return;
      }

      setTimeout(() => {
        this.show();
        window.localStorage.setItem("showNewsletterPopin", "false");
      }, delay * 1000);
    };

    onSubmitButtonClick = (event) => {
      event.preventDefault();

      this.hideErrors();

      const isEmailValid = this.emailInput.checkValidity();
      const isCheckboxChecked = this.confidentialityCheckbox.checked;

      if (!isEmailValid) {
        this.showEmailError();
      }

      if (!isCheckboxChecked) {
        this.showCheckboxError();
      }

      if (isEmailValid && isCheckboxChecked) {
        this.form.submit();
        return true;
      }

      return false;
    };

    onFormSubmit = (event) => {
      // Prevent any accidental form submissions (e.g., Enter key)
      event.preventDefault();
      return false;
    };

    onEmailInput = () => {
      // Clear email error when user starts typing a valid email
      if (this.emailInput.checkValidity() && this.emailErrorElement) {
        this.emailErrorElement.setAttribute("aria-hidden", "true");
      }
    };

    onCheckboxChange = () => {
      // Clear checkbox error when user checks the box
      if (this.confidentialityCheckbox.checked && this.checkboxErrorElement) {
        this.checkboxErrorElement.setAttribute("aria-hidden", "true");
      }
    };

    show = () => {
      this.modifiers.add("popin-open");
      window.zag.utils.documentScroll.isLocked = true;
    };

    hide = () => {
      this.modifiers.remove("popin-open");
      window.zag.utils.documentScroll.isLocked = false;
    };

    showEmailError = () => {
      if (this.emailErrorElement) {
        this.emailErrorElement.setAttribute("aria-hidden", "false");
      }
    };

    showCheckboxError = () => {
      if (this.checkboxErrorElement) {
        this.checkboxErrorElement.setAttribute("aria-hidden", "false");
      }
    };

    hideErrors = () => {
      if (this.emailErrorElement) {
        this.emailErrorElement.setAttribute("aria-hidden", "true");
      }
      if (this.checkboxErrorElement) {
        this.checkboxErrorElement.setAttribute("aria-hidden", "true");
      }
    };
  };
  if (!window.customElements.get("zag-newsletter-popin")) {
    window.customElements.define(
      "zag-newsletter-popin",
      window.zag.components.ZagNewsletterPopin
    );
  }
})();
